// extracted by mini-css-extract-plugin
module.exports = {"star-active":"_QuestionAction_star-active_3BxP_","star":"_QuestionAction_star_1rhwv","box-size":"_QuestionAction_box-size_2dpa8"};